import { useEffect, useCallback } from 'react'
import { useToast } from '@t-one-internal/design-system'
import { useRecognitionStore } from '../stores/recognitionStore'
import { recognitionService } from '../services/recognitionService'

/**
 * Data-fetching hook for the Leaderboard tab.
 * Call in LeaderboardView — refetches when tab, period, or page changes.
 */
export function useLeaderboardData() {
  const { toast } = useToast()

  const tab = useRecognitionStore((s) => s.leaderboardTab)
  const period = useRecognitionStore((s) => s.leaderboardPeriod)
  const page = useRecognitionStore((s) => s.leaderboardPage)
  const pageSize = useRecognitionStore((s) => s.leaderboardPageSize)
  const setLeaderboard = useRecognitionStore((s) => s.setLeaderboard)
  const setLeaderboardLoading = useRecognitionStore((s) => s.setLeaderboardLoading)
  const setError = useRecognitionStore((s) => s.setError)

  const fetchLeaderboard = useCallback(async () => {
    setLeaderboardLoading(true)
    try {
      const pageOffset = (page - 1) * pageSize
      const result = await recognitionService.getLeaderboard({ tab, period, page_size: pageSize, page_offset: pageOffset })
      setLeaderboard(result.data, result.total)
    } catch {
      const message = 'Failed to load leaderboard'
      setError(message)
      toast({ title: 'Error', description: message, variant: 'destructive' })
    } finally {
      setLeaderboardLoading(false)
    }
  }, [tab, period, page, pageSize, setLeaderboard, setLeaderboardLoading, setError, toast])

  useEffect(() => {
    fetchLeaderboard()
  }, [fetchLeaderboard])

  return { fetchLeaderboard }
}
